"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../../../../theme/styled-components"));
var Product_1 = tslib_1.__importDefault(require("../Product"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  overflow-x: auto;\n"], ["\n  display: flex;\n  overflow-x: auto;\n"])));
var InnerWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin: auto;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: auto;\n"])));
var Item = styled_components_1["default"].a(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  :not(:last-child) {\n    margin-right: ", ";\n  }\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  :not(:last-child) {\n    margin-right: ", ";\n  }\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), maxWidth);
});
var FullRotation = function (_a) {
    var width = _a.width, items = _a.items;
    return (react_1["default"].createElement(Wrapper, null,
        react_1["default"].createElement(InnerWrapper, null, items.map(function (item, idx) {
            return (react_1["default"].createElement(Item, { title: item.title, href: item.url || undefined, target: "_blank", as: item.url ? 'a' : 'span', key: idx, maxWidth: width },
                react_1["default"].createElement(Product_1["default"], tslib_1.__assign({}, item))));
        }))));
};
exports["default"] = FullRotation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
